import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Canvas, CanvasHandle } from '../../../components/Canvas';
import BackDiagram from './sral-back.svg';
import FrontDiagram from './sral-front.svg';

import styles from './index.module.css';
import { Side } from '../../../utils/enum';
import { CanvasPath } from 'react-sketch-canvas/src/types';
import { MutableRefObject, useRef, useState } from 'react';
import { Button } from '../../../components/Button';

interface Props {
  side: Side;
  brushColor?: string;
  defaultPaths?: CanvasPath[];
  onChange?: (paths: CanvasPath[]) => void;
  classname?: string;
}

interface DiagramMetaData {
  screenLeftString: string;
  screenRightString: string;
  imageSource: string;
}

export const FreehandBodyDiagramInput = React.forwardRef(
  (
    { side, brushColor, defaultPaths, onChange, classname }: Props,
    forwardRef: React.Ref<CanvasHandle | null>,
  ) => {
    const { t } = useTranslation();
    const { screenLeftString, screenRightString, imageSource } =
      DIAGRAM_DATA[side];
    const ref = useRef<CanvasHandle | null>(null);
    const [drawn, setDrawn] = useState(false);
    return (
      <div className={styles.DiagramContainer}>
        <div className={styles.SideLabels}>
          <div>{t(screenLeftString)} </div>
          <div>{t(screenRightString)}</div>
        </div>
        <div className={styles.CanvasContainer}>
          <Canvas
            ref={(node) => {
              ref.current = node;
              if (typeof forwardRef === 'function') {
                forwardRef(node);
              } else if (forwardRef) {
                (forwardRef as MutableRefObject<CanvasHandle | null>).current =
                  node;
              }
            }}
            className={styles.Canvas}
            backgroundImage={imageSource}
            brushColor={brushColor}
            defaultPaths={defaultPaths}
            onChange={(paths) => {
              setDrawn(!!paths.length);
              onChange && onChange(paths);
            }}
          />
        </div>

        {drawn && (
          <Button
            type="button"
            children={t('Clear shaded area')}
            invertColors={true}
            onClick={() => ref.current?.clear()}
            className={styles.SecondaryButton}
          />
        )}
      </div>
    );
  },
);

const DIAGRAM_DATA: Record<Side, DiagramMetaData> = {
  [Side.Front]: {
    screenLeftString: 'Front right',
    screenRightString: 'Front left',
    imageSource: FrontDiagram,
  },
  [Side.Back]: {
    screenLeftString: 'Back left',
    screenRightString: 'Back right',
    imageSource: BackDiagram,
  },
};
